/**
 * Created by David Pohan <david.pohan@keyup.eu> on 10/27/2015.
 */
import fetch from 'isomorphic-fetch';
import {Record, Map} from 'immutable';
import constants from '../constants';

const InitialOptions = Record({
    query: Map({}),
    headers: new (Record({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': null,
        'DownloadDomain': null,
        'X-App-Type': 'pos'
    })),
    body: null
});
let initialOptions = new InitialOptions;

let instance = null;

class Http {
    constructor() {
        if (!instance) {
            instance = this; // eslint-disable-line consistent-this
        }
    }

    get(endpoint, options = {}, timeout = 0) {
        if (!!timeout) {
            return this._timeoutRequest('get', endpoint, options, timeout);
        } else {
            return this._request('get', endpoint, options);
        }
    }

    post(endpoint, options = {}, timeout = 0) {
        if (!!timeout) {
            return this._timeoutRequest('post', endpoint, options, timeout);
        } else {
            return this._request('post', endpoint, options);
        }
    }

    delete(endpoint, options = {}, timeout = 0) {
        if (!!timeout) {
            return this._timeoutRequest('delete', endpoint, options, timeout);
        } else {
            return this._request('delete', endpoint, options);
        }
    }

    setAuthorization(token) {
        initialOptions = initialOptions.setIn(['headers', 'Authorization'], token);
    }

    async _timeoutRequest(method, endpoint, _options, timeout) {
        const options = initialOptions.merge(_options);

        const timeoutPromise = new Promise((resolve, reject) => {
            setTimeout(reject, timeout, 'request timed out');
        });
        const res = fetch(
            this._createUrl(endpoint, options.get('query').toJS()),
            this._createOptions(method, options)
        );

        const promise = await Promise.race([timeoutPromise, res]);
        if (promise.status < 300) {
            return promise;
        }
        throw promise;
    }

    async _request(method, endpoint, _options) {
        const options = initialOptions.merge(_options);
        const res = await fetch(
            this._createUrl(endpoint, options.get('query').toJS()),
            this._createOptions(method, options)
        );

        if (res.status < 300) {
            return res;
        }
        throw res;
    }

    _createOptions(method, _options) {
        let options = {
            headers: this._createHeaders(_options),
            method: method
        };
        // do not serialize the request body for unsupported methods
        if (['get', 'head', 'delete'].indexOf(method.toLowerCase()) === -1) {
            const body = _options.get('body');
            if (body instanceof FormData) { // eslint-disable-line no-undef
                options['body'] = body;
                delete options.headers['Content-Type'];
            } else {
                options['body'] = JSON.stringify(body);
            }
        }
        return options;
    }

    _createHeaders(options) {
        let headers = options.get('headers').toJS();
        const localDomain = localStorage.getItem('domain');
        if (localDomain && !(headers['domain'])) {
            headers['DownloadDomain'] = localDomain;
        }
        if (!headers['Authorization']) {
            delete headers['Authorization'];
        }
        return headers;
    }

    _createUrl(endpoint, queryData) {
        return constants.API_URL + endpoint + this._createQuery(queryData);
    }

    _createQuery(queryData) {
        let query = '';
        Object.keys(queryData).forEach((key, i, arr) => {
            const value = queryData[key];
            if (typeof value !== 'undefined') {
                if (i === 0) query += '?';
                if (i > 0 && i < arr.length) query += '&';
                query += `${key}=${value}`;
            }
        });
        return query;
    }
}

export default new Http;




// WEBPACK FOOTER //
// ./src/common/lib/http.js